// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item-label .el-form-item[data-v-cf7e8da2] .el-form-item__label {\n  width: 105px !important;\n}\n.form-item-label .el-form-item[data-v-cf7e8da2] .el-form-item__content {\n  margin-left: 105px !important;\n}\n.poNoClass[data-v-cf7e8da2] .el-input.is-disabled .el-input__inner {\n  color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
